import React, { useEffect } from 'react'
import styled from 'styled-components'
import { handleEventLog } from '../../../../lib/utils'

const MainBox = styled.div`
  background: ${({ wordCount }) =>
  wordCount ? wordCount >= 2500 ? 'rgba(19, 198, 85, 0.10)' : 'rgba(3, 138, 227, 0.1)' : wordCount >= 1000 ? 'rgba(19, 198, 85, 0.10)' : 'rgba(3, 138, 227, 0.1)'};
  max-width: 800px;
  margin: auto;
  padding: 2px 5%;
`
const ProgressBar = styled.div`
  height: 8px;
  margin: auto;
  border-radius: 64px;
  background: rgba(3, 138, 227, 0.2);
  margin: 4px 0;
`
const Progress = styled.div`
  height: 8px;
  width: ${({ wordCount }) =>
  wordCount ? wordCount > 2500 ? '100%' : `${wordCount / 25}%` : wordCount > 1000 ? '100%' : `${wordCount / 10}%`};
  background: #13c655;
  border-radius: 64px;
`

const TextDiv = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 4px 0;
`

const CopyText = styled.p`
  color: #3e3e3e;
  text-align: center;
  font-family: 'Noto Sans';
  font-size: 10px;
  font-weight: 500;

  span {
    font-size: 20px;
  }
`

const Incentive = styled.p`
  color: #16a34a;
  font-family: 'Noto Sans';
  font-size: 14px;
  font-weight: 700;
  & span {
    font-weight: 500;
    margin-right: 4px;
    font-size: 10px;
    color: #3e3e3e;
  }
`
const WordsDiv = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 4px 0;

  p {
    color: #000;
    font-family: 'Noto Sans';
    font-size: 10px;
    font-weight: 500;
  }
`

const IncentiveGoalBox = ({ wordCount, publishBonus = '0', chapter_id, wordCountCap }) => {
  useEffect(() => {
    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver(
        ([entry]) => {
          if (entry.isIntersecting && entry.intersectionRatio > 0.9)
            handleEventLog('editor', 'impressions', {
              entity_id: chapter_id || '',
              module_name: 'incentive_progress',
              entity_type: 'chapter'
            })
        },
        {
          threshold: 0.9,
        }
      )
      const incentive_goal_box = document.getElementById('incentive_goal_box')
      observer.observe(incentive_goal_box)
      return () => observer.disconnect()
    }
  }, [])

  const getTextCopy = () => {
    if (wordCount === 0) return 'Start your chapter, Unlock a special bonus!'
    if (wordCount >= 1000)
      return 'Ready to publish? Claim your 1st Publish bonus now!'
    if (wordCount > 0) return 'Keep writing! A bonus awaits at 1000 words...'
  }
  const getTextCopyVariantB = () => {
    if (wordCount === 0) return 'Start your chapter, unlock daily update bonus!'
    if (wordCount >= 2500)
      return 'Ready to publish? Claim your daily update bonus !'
    if (wordCount > 0) return 'Keep writing! Maximize your daily update bonus'
  }
  return (
    <MainBox wordCount={wordCount} id="incentive_goal_box">
      <TextDiv>
        <CopyText>
          <span>🎯</span>&nbsp;&nbsp;{getTextCopyVariantB() || getTextCopy()} 
        </CopyText>
        <Incentive> <span>upto</span>₹ {publishBonus}</Incentive>
      </TextDiv>

      <ProgressBar>
        <Progress wordCount={wordCount}></Progress>
      </ProgressBar>
      <WordsDiv>
        <p>0</p> <p>{wordCountCap || 1000}</p>
      </WordsDiv>
    </MainBox>
  )
}

export default IncentiveGoalBox
